import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const Navigation = styled.nav`
  position: relative;
  width: 100%;
  padding: 15px 0;
  padding-left: 25px;
  color: rgba(255, 255, 255, 0.5);

  a {
    opacity: 0.5;
    color: #fff;
    transition: opacity 0.15s ease;

    &:hover {
      opacity: 1;
    }
  }

  li {
    display: inline-block;
    position: relative;
    padding-left: 24px;
    margin-right: 12px;

    /* stylelint-disable */
    &:last-child:not(:only-child) {
      ${maxMediaQueries.phone`
        display: none;
      `};
    }
    /* stylelint-enable */
  }

  svg:not(:only-child) {
    position: absolute;
    top: 4px;
    left: -3px;
    opacity: 0.4;
  }
`;
